import { useState } from "react";
import { FleetVehicleExpenseStats } from "services/api/fleet/vehicles/expenses/types";
import Tabs from "ui/components/Tabs/Tabs";
import VehicleExpenseMonthly from "./components/VehicleExpenseMonthly/VehicleExpenseMonthly";
import VehicleExpenseWeekly from "./components/VehicleExpenseWeekly/VehicleExpenseWeekly";

interface VehicleExpenseStatsProps {
    // Funkcija koja dohvaća stats. Per-vehicle koristi
    // `() => getFleetVehicleExpenseStatsAPI(vehicleId)`, tenant-wide koristi
    // `getAllVehicleExpenseStatsAPI` (Finance > Troškovi > Statistika).
    fetchStats: () => Promise<FleetVehicleExpenseStats>;
    // Opcionalni overrides za header — bez ovih ostaje stari per-vehicle default.
    title?: string;
    subtitle?: string;
}

const VehicleExpenseStats: React.FC<VehicleExpenseStatsProps> = ({ fetchStats, title, subtitle }) => {
    // Per-tab refresh keys — increment kad korisnik kine na tab da forsa remount + refetch
    const [monthlyKey, setMonthlyKey] = useState<number>(0);
    const [weeklyKey, setWeeklyKey] = useState<number>(0);
    const [activeIndex, setActiveIndex] = useState<number>(0);

    const handleTabChange = (index: number) => {
        setActiveIndex(index);
        if (index === 0) setMonthlyKey(k => k + 1);
        if (index === 1) setWeeklyKey(k => k + 1);
    };

    return (
        <div className="rounded-sm px-4 py-5 text-slate-700 flex flex-col h-[800px] bg-white border mt-[-1px]">
            <Tabs
                variant="pill"
                queryParamName="period"
                activeIndex={activeIndex}
                onTabChange={handleTabChange}
                tabs={[
                    {
                        label: "Mjesečni prikaz",
                        queryParam: "month",
                        content: <VehicleExpenseMonthly key={`monthly-${monthlyKey}`} fetchStats={fetchStats} title={title} subtitle={subtitle} />,
                    },
                    {
                        label: "Tjedni prikaz",
                        queryParam: "week",
                        content: <VehicleExpenseWeekly key={`weekly-${weeklyKey}`} fetchStats={fetchStats} title={title} subtitle={subtitle} />,
                    },
                ]}
            />
        </div>
    );
};

export default VehicleExpenseStats;
